export const PROPERTIES = {
    EXTENSION_APPLICATION: 'ExtensionApplication',
    HEIGHT_PX: 'HeightPX',
};
